module.exports = __webpack_public_path__ + "img/Maria-Reboredo.d5a8d3e2.jpg";